export const displayOptionsConfig = {
  displayAll: true,
  elementId: true,
  displayValue: true,
  scaledValue: true,
  pageNo: true,
  label: true,
  status: true,
  workpaper: true,
  tickmarks: true,
  formula: true,
  internalRef: true,
  comfortLetter: true,
  scaling: true,
  units: true,
  period: true,
  entity: true,
};

const REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID = 'report-preview-page-id';

export const OPTIONS_CHECKBOX_ARRAY = [
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-displayAll-checkbox`,
    name: 'displayAll',
    key: '1',
    reOrderKey: 'displayAll',
    label: 'report.preview.displayAll.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-elementId-checkbox`,
    name: 'elementId',
    key: '2',
    reOrderKey: 'id',
    label: 'report.preview.elementId.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-displayValue-checkbox`,
    name: 'displayValue',
    key: '3',
    reOrderKey: 'display',
    label: 'report.preview.displayValue.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-scaledValue-checkbox`,
    name: 'scaledValue',
    key: '4',
    reOrderKey: 'amount',
    label: 'report.preview.scaledValue.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-pageNo-checkbox`,
    name: 'pageNo',
    key: '5',
    reOrderKey: 'sectionId',
    label: 'report.preview.pageNo.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-label-checkbox`,
    name: 'label',
    key: '6',
    reOrderKey: 'label',
    label: 'report.preview.label.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-status-checkbox`,
    name: 'status',
    key: '7',
    reOrderKey: 'status',
    label: 'report.preview.status.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-workpaperReference-checkbox`,
    name: 'workpaper',
    key: '8',
    reOrderKey: 'workpaperReferenceNumbers',
    label: 'report.preview.workpaper.reference.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-tickmarks-checkbox`,
    name: 'tickmarks',
    key: '9',
    reOrderKey: 'tickmarks',
    label: 'report.preview.tickmarks.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-footedFormulas-checkbox`,
    name: 'formula',
    key: '10',
    reOrderKey: 'formulaCell',
    label: 'report.preview.footed.formulas.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-internalReferences-checkbox`,
    name: 'internalRef',
    key: '11',
    reOrderKey: 'internalReference',
    label: 'report.preview.internal.references.label',
  },

  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-comfortLetter-checkbox`,
    name: 'comfortLetter',
    key: '12',
    reOrderKey: 'comfortLetterlabelList',
    label: 'report.preview.comfort.letter.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-scaling-checkbox`,
    name: 'scaling',
    key: '13',
    reOrderKey: 'scaling',
    label: 'report.preview.scaling.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-units-checkbox`,
    name: 'units',
    key: '14',
    reOrderKey: 'units',
    label: 'report.preview.units.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-period-checkbox`,
    name: 'period',
    key: '15',
    reOrderKey: 'period',
    label: 'report.preview.period.label',
  },
  {
    id: `${REPORT_PREVIEW_PAGE_OPTIONS_DROPDOWN_ID}-entity-checkbox`,
    name: 'entity',
    key: '16',
    reOrderKey: 'entity',
    label: 'report.preview.entity.label',
  },
];
